"use client";

import Link from "next/link";
import { Menu } from "lucide-react";
import { Button } from "./ui/button";
import { ThemeToggle } from "./theme-toggle";
import { useState } from "react";
import { Wordmark } from "./ui/wordmark";
import { Logo } from "./ui/logo";
import { UserMenu } from "./user-menu";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container max-w-screen-xl mx-auto px-4 sm:px-6 flex items-center justify-between py-3">
        {/* Logo */}
        <div className="flex items-center">
          <Link href="/" className="flex items-center space-x-3">
            <Logo size={80} className="block" />
            <Wordmark size="xl" className="h-1/2" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-end space-x-2">
          <nav className="flex items-center space-x-4">
            <Link
              href="/analyze"
              className="text-sm font-medium transition-colors hover:text-secondary"
            >
              Analyze
            </Link>
            <Link
              href="/pricing"
              className="text-sm font-medium transition-colors hover:text-secondary"
            >
              Pricing
            </Link>
            <Link
              href="/#techniques"
              className="text-sm font-medium transition-colors hover:text-secondary"
            >
              Techniques
            </Link>
            <Link
              href="/support"
              className="text-sm font-medium transition-colors hover:text-secondary"
            >
              Support
            </Link>
          </nav>
          <div className="flex items-center space-x-2">
            <ThemeToggle />
            <UserMenu />
          </div>
        </div>

        {/* Mobile Navigation Controls */}
        <div className="flex md:hidden items-center space-x-2">
          <ThemeToggle />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            className="text-secondary hover:text-secondary/80"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background border-b border-border px-4 py-3 shadow-md">
          <nav className="flex flex-col space-y-3">
            <Link
              href="/analyze"
              className="text-base font-medium p-2 hover:bg-secondary/10 rounded-md transition-colors hover:text-secondary"
              onClick={() => setMobileMenuOpen(false)}
            >
              Analyze
            </Link>
            <Link
              href="/pricing"
              className="text-base font-medium p-2 hover:bg-secondary/10 rounded-md transition-colors hover:text-secondary"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              href="/#techniques"
              className="text-base font-medium p-2 hover:bg-secondary/10 rounded-md transition-colors hover:text-secondary"
              onClick={() => setMobileMenuOpen(false)}
            >
              Techniques
            </Link>
            <Link
              href="/support"
              className="text-base font-medium p-2 hover:bg-secondary/10 rounded-md transition-colors hover:text-secondary"
              onClick={() => setMobileMenuOpen(false)}
            >
              Support
            </Link>
            <div className="pt-2 pb-1">
              <UserMenu />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
